import { ArrowLeft } from 'lucide-react';
import { useNavigate, Link } from 'react-router';
import { Button } from '../components/ui/button';
import { StockHeroStrip, WarmMarketingBackdrop } from '../components/marketing/MarketingVisuals';
import {
  MARKETING_STOCK,
  MARKETING_STOCK_CREDITS,
  unsplashPhotoPageUrl,
} from '../lib/marketing-stock';
import { useSEO } from '../lib/seo';

export default function PhotoCredits() {
  const navigate = useNavigate();

  useSEO({
    title: 'Photo credits | TENSION',
    description:
      'Illustrative marketing photos are sourced from Unsplash. License and per-image links.',
    keywords: ['Unsplash', 'photo credits', 'stock photos', 'TENSION'],
    canonical: '/photo-credits',
    ogType: 'website',
    twitterCard: 'summary',
  });

  return (
    <WarmMarketingBackdrop>
      <div className="mx-auto max-w-4xl px-6 py-8">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-6"
          aria-label="Go back"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back
        </Button>

        <StockHeroStrip stockKey="coupleOutdoor" alt="Illustrative stock imagery" />

        <div className="mt-8 rounded-xl border border-violet-100/90 bg-white/95 p-8 shadow-lg">
          <h1 className="mb-2 text-3xl font-light text-neutral-900">Photo credits</h1>
          <p className="mb-6 text-sm text-neutral-500">
            Marketing pages use curated illustrative imagery from{' '}
            <a
              href="https://unsplash.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-violet-700 underline hover:text-violet-800"
            >
              Unsplash
            </a>
            . Under the{' '}
            <a
              href="https://unsplash.com/license"
              target="_blank"
              rel="noopener noreferrer"
              className="text-violet-700 underline hover:text-violet-800"
            >
              Unsplash License
            </a>
            , attribution is not required; we publish this list so sources are easy to find.
          </p>

          <h2 className="mb-3 text-lg font-medium text-neutral-900">Images in use</h2>
          <ul className="space-y-3 text-neutral-700">
            {MARKETING_STOCK_CREDITS.map(({ key, label }) => {
              const id = MARKETING_STOCK[key];
              const href = unsplashPhotoPageUrl(id);
              return (
                <li key={key}>
                  <span className="text-neutral-800">{label}</span>
                  {' — '}
                  <a
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-violet-700 underline hover:text-violet-800"
                  >
                    View on Unsplash
                  </a>
                </li>
              );
            })}
          </ul>

          <p className="mt-8 text-sm text-neutral-500">
            <Link to="/site-map" className="text-violet-700 underline hover:text-violet-800">
              Site map
            </Link>
          </p>
        </div>
      </div>
    </WarmMarketingBackdrop>
  );
}
